import "./modal.css"
import React from "react"

export const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none"

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {/* Top-right close icon */}
        <button className="close-icon-btn" onClick={handleClose} aria-label="Close modal">
          &times;
        </button>

        <div className="modal-content-wrapper">
          {children}
        </div>

        {/* Optional bottom button - you can remove this if the X is enough */}
        {/* <div className="modal-close" onClick={handleClose}>
          Close
        </div> */}
      </section>
    </div>
  )
}